import { ICalendarGroupedEvents } from './CattlePoCalendarInterface';

export const CALENDAR_INITIAL_STATE: {
    events: ICalendarGroupedEvents;
} = {
    events: {},
};
